import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// The settings lists of each station type, keyed in their own tabs.
const STATION_LIST_QUERY_KEYS = [
  "visitorStations",
  "roomDisplayStations",
  "wayfinderStations"
];

/**
 * Invalidates the station lists of every type (visitor, room display and
 * wayfinder). Use after changing a station from a view shared by all of them.
 */
export const useInvalidateVisitorStations = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await Promise.all(
      STATION_LIST_QUERY_KEYS.map((key) =>
        queryClient.invalidateQueries({ queryKey: [key] })
      )
    );
  }, [queryClient]);
};
